import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ACCTRANS,
  GET_ACCTRANS_ONE,
  DELETE_ACCTRANS,
  UPDATE_ACCTRANS,
  ADD_NEW_ACCTRANS,
} from "./actionType";

import {
  getAccTransSuccess,
  getAccTransFail,
  deleteAccTransSuccess,
  deleteAccTransFail,
  updateAccTransSuccess,
  updateAccTransFail,
  addAccTransSuccess,
  addAccTransFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAccTransApi,
  getAccTransApi,
  updateAccTransApi,
  deleteAccTransApi,
  addNewAccTransApi,
  getOneAccTransApi
} from "../../helpers/backend_helper";

function* getAccTrans({ payload: accTrans }) {
  try {
    const response = yield call(getAccTransApi, accTrans);
    yield put(getAccTransSuccess(GET_ACCTRANS, response.data));
  } catch (error) {
    yield put(getAccTransFail(GET_ACCTRANS, error));
  }
}

function* getAccTransOne({ payload: id }) {
  try {
    const response = yield call(getOneAccTransApi, id);
    yield put(getAccTransSuccess(GET_ACCTRANS_ONE, response.data));
  } catch (error) {
    yield put(getAccTransFail(GET_ACCTRANS_ONE, error));
  }
}

function* onUpdateAccTrans({ payload: accTrans }) {
  try {
    if (accTrans.setApprove) {
      const response = yield call(approveAccTransApi, accTrans);
      yield put(updateAccTransSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAccTransApi, accTrans);
      yield put(updateAccTransSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAccTransFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccTrans({ payload: accTrans }) {
  try {
    const response = yield call(deleteAccTransApi, accTrans);
    yield put(deleteAccTransSuccess({ accTrans, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccTransFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccTrans({ payload: accTrans }) {
  try {
    const response = yield call(addNewAccTransApi, accTrans);
    yield put(addAccTransSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccTransFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAccTrans() {
  yield takeEvery(GET_ACCTRANS, getAccTrans);
}

export function* watchGetAccTransOne() {
  yield takeEvery(GET_ACCTRANS_ONE, getAccTransOne);
}

export function* watchUpdateAccTrans() {
  yield takeEvery(UPDATE_ACCTRANS, onUpdateAccTrans);
}

export function* watchDeleteAccTrans() {
  yield takeEvery(DELETE_ACCTRANS, onDeleteAccTrans);
}

export function* watchAddNewAccTrans() {
  yield takeEvery(ADD_NEW_ACCTRANS, onAddNewAccTrans);
}

function* accTransSaga() {
  yield all([
    fork(watchGetAccTrans),
    fork(watchGetAccTransOne),
    fork(watchDeleteAccTrans),
    fork(watchUpdateAccTrans),
    fork(watchAddNewAccTrans)
  ]);
}

export default accTransSaga;
